<template>
    <div class="page">
        <div class="radio-box">
            <div
                class="item"
                @click="changeMethod(0)"
                :class="[method == 0 ? 'active' : '']"
            >
                <div class="top">
                    <div class="left method">我要邮寄</div>
                    <div class="radio"></div>
                </div>
            </div>
            <div class="item" :class="[method == 1 ? 'active' : '']">
                <div class="top" @click="changeMethod(1)">
                    <div class="left">
                        <div class="method">我要自提</div>
                        <div>自提地点：四川省成都市锦江区成都报业大厦</div>
                        <div>自提时间：工作日10:00-16:00</div>
                        <div>自提预约请联系道达号客服微信：daodahao1997</div>
                        <input class="hide" type="text" />
                    </div>
                    <div class="radio"></div>
                </div>
                <div class="bottom copy" @click="copy()">一键复制地址</div>
            </div>
        </div>
        <div class="form-box" :class="[method == 0 ? 'active' : '']">
            <van-form class="form" @submit="onSubmit">
                <div>
                    <van-field
                        v-model="info.name"
                        name="收货人"
                        label="收货人"
                        placeholder="请输入收货人姓名"
                        :rules="[
                            { required: true, message: '请输入收货人姓名' },
                        ]"
                    />
                    <van-field
                        v-model="info.phone"
                        name="联系电话"
                        label="联系电话"
                        placeholder="请输入联系电话"
                        type="tel"
                        :rules="[{ required: true, message: '请输入联系电话' }]"
                    />
                    <van-field
                        readonly
                        clickable
                        name="picker"
                        :value="info.areaStr"
                        label="收货地址"
                        placeholder="请选择省/市/区"
                        @click="showPicker = true"
                        :rules="[{ required: true, message: '请选择省/市/区' }]"
                    />
                    <van-popup v-model="showPicker" position="bottom">
                        <van-area
                            title="请选择省/市/区"
                            :area-list="areaList"
                            @confirm="selCity($event)"
                            @cancel="showPicker = false"
                            :value="cityCode"
                        />
                    </van-popup>
                    <van-field
                        v-model="info.address"
                        name="详细地址"
                        label="详细地址"
                        placeholder="请输入详细地址"
                        :rules="[{ required: true, message: '请输入详细地址' }]"
                    />
                </div>
                <div class="btn-box">
                    <van-button
                        class="submit"
                        round
                        block
                        type="info"
                        native-type="submit"
                    >
                        提交
                    </van-button>
                </div>
            </van-form>
        </div>
        <div class="btn-box" :class="[method == 1 ? 'active' : '']">
            <van-button
                class="submit"
                round
                block
                type="info"
                native-type="submit"
                @click="onSubmit()"
            >
                提交
            </van-button>
        </div>

        <div class="zz" :class="[showModalName ? 'active' : '']">
            <div class="container">
                <div
                    class="modal form-success"
                    :class="[showModalName == 'form-success' ? 'active' : '']"
                >
                    <img
                        class="success-logo"
                        src="~@/assets/gift/success.png"
                        alt=""
                    />
                    <div class="title">提交成功</div>
                    <div class="intro">
                        我们已收到您的收件信息。<br />
                        产品将在信息汇总后统一邮寄，<br />
                        长按扫码添加客服，领取课程直播和福利信息<br />
                    </div>
                    <img class="qrcode" :src="info.kefu" alt="" />
                    <button class="close" @click="goCourseList()">确定</button>
                </div>

                <div
                    class="modal ziti"
                    :class="[showModalName == 'ziti' ? 'active' : '']"
                >
                    <img
                        class="success-logo"
                        src="~@/assets/gift/success.png"
                        alt=""
                    />
                    <div class="title">提交成功</div>
                    <div class="intro">
                        自提地点：<b>四川省成都市锦江区成都报业大厦</b><br />
                        自提时间：<b>工作日10:00-16:00</b><br />
                        自提预约请联系道达号客服微信号： <br />
                        <b>daodahao1997</b>
                    </div>
                    <button class="close" @click="goCourseList('')">
                        确定
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import areaList from "../../citys.js";
    import { Info } from "../../types/get-prize-method";
    import { Toast } from "vant";
    import payService from "../../service/pay.service";
    export default {
        name: "get-prize-method",
        data() {
            return {
                method: 0,
                areaList,
                showPicker: false,
                info: new Info(),
                showModalName: "",
                cityCode: undefined,
                loading: false,
                a: { b: [] },
            };
        },
        created() {
            this.getMyAddress();
        },
        methods: {
            goCourseList() {
                this.showModal("");
                this.$router.push("/course-list");
            },
            showModal(name) {
                this.showModalName = name;
            },
            getMyAddress() {
                payService.getMyAddress().then((res) => {
                    this.info = Object.assign({}, this.info, res.data);

                    if (this.info.areaStr.length > 0) {
                        for (let key in areaList.province_list) {
                            if (
                                this.info.area.province ==
                                areaList.province_list[key]
                            ) {
                                this.cityCode = key.slice(0, 2);
                                break;
                            }
                        }
                        for (let key in areaList.city_list) {
                            if (
                                this.info.area.city == areaList.city_list[key]
                            ) {
                                this.cityCode += key.slice(2, 4);
                                break;
                            }
                        }
                        for (let key in areaList.county_list) {
                            if (
                                this.info.area.country ==
                                areaList.county_list[key]
                            ) {
                                this.cityCode += key.slice(4);
                                break;
                            }
                        }
                    }
                });
            },
            changeMethod(index) {
                this.method = index;
            },
            copy() {
                if (this.method == 0) {
                    return;
                }
                let inputEl = document.querySelector("input.hide");
                inputEl.value = "四川省成都市锦江区成都报业大厦";
                inputEl.select();
                document.execCommand("copy");
                Toast("复制成功");
            },
            selCity(e) {
                this.info.area.province = e[0].name;
                this.info.area.city = e[1].name;
                this.info.area.country = e[2].name;
                this.info.areaStr = `${e[0].name}/${e[1].name}/${e[2].name}`;
                this.showPicker = false;
            },
            onSubmit() {
                let obj = {
                    ziti: false,
                    id: this.$route.query.id,
                };
                if (this.method == 1) {
                    obj.ziti = true;
                } else {
                    if (!this.info.name) {
                        Toast("请填写收货人");
                        return;
                    }
                    if (!this.info.phone) {
                        Toast("请填写联系电话");
                        return;
                    }
                    if (!this.info.areaStr) {
                        Toast("请选择收货地址");
                        return;
                    }
                    if (!this.info.address) {
                        Toast("请填写详细地址");
                        return;
                    }
                }
                if (this.loading) {
                    return;
                }
                this.loading = true;
                payService
                    .getPrize(Object.assign({}, this.info, obj))
                    .then(() => {
                        if (this.method == 0) {
                            this.showModal("form-success");
                        } else if (this.method == 1) {
                            this.showModal("ziti");
                        }
                        this.loading = false;
                    });
            },
        },
    };
</script>

<style lang="scss" scoped src="./get-prize-method.scss"></style>
